import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

import { ServerValidationError } from '@/api/shared/types'

import { RequestsService } from '../lib/requests.service'
import type {
  CreateRequestApi,
  CreateServicePassDTO
} from '../lib/requests.types'
import { REQUESTS_LIST_RQ_KEY } from './useRequestsList'

export const useCreateRequestPass = () => {
  const queryClient = useQueryClient()

  return useMutation<
    AxiosResponse<CreateRequestApi>,
    AxiosError<ServerValidationError>,
    CreateServicePassDTO
  >({
    mutationFn: (data: CreateServicePassDTO) =>
      RequestsService.createServicePass(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [REQUESTS_LIST_RQ_KEY]
      })
    }
  })
}
